// @flow
import PlainList, { type Props, type ChildrenItemProps } from './plain-list';


export default PlainList;

export type { Props, ChildrenItemProps };
